import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { withRouter } from "../../_shared/withRouter";
import { globalLoader, globalAlert } from "../../actions/commonActions";
import { validEmail } from "../../_shared/commonFunction";
import {
  superAdminGenResetApi,
  superAdminValidateMailApi,
} from "../../superadmin/_actions";
import { validateMailApi, genResetApi } from "../../admin/_actions";
import InputComponent from "../_common/inputComponent";

const ForgotPasswordComponent = (props) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [emptyEmail, setEmptyEmail] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [validtedEmail, setValidtedEmail] = useState(false);
  const [linkSent, setLinkSent] = useState(false);
  const [sentMsg, setSentMsg] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setEmptyEmail(true);
      return;
    }
    if (email && !invalidEmail) {
      const roleType = props.roleType;
      globalLoader(true);
      let res;
      let obj = {
        email: email,
      };
      if (!validtedEmail) {
        if (roleType === "admin") {
          res = await validateMailApi(obj);
        } else if (roleType === "superadmin") {
          res = await superAdminValidateMailApi(obj);
        }

        if (res?.data?.status === 200) {
          setValidtedEmail(true);
        } else {
          globalAlert("error", res?.data?.message);
        }
      } else {
        if (roleType === "admin") {
          res = await genResetApi(obj);
        } else if (roleType === "superadmin") {
          res = await superAdminGenResetApi(obj);
        }

        if (res?.data?.status === 200) {
          setLinkSent(true);
          setSentMsg(res?.data?.message);
        } else {
          globalAlert("error", res?.data?.message);
        }
      }

      globalLoader(false);
    }
  };

  const validateMail = async (ev) => {
    let value = ev.target.value;
    let valid = await validEmail(value);
    if (valid) {
      setInvalidEmail(false);
    } else {
      setInvalidEmail(true);
    }
    setEmail(value);
  };

  return (
    <>
      <div className="auth-screen-wrapper">
        <div className="fix-width-wrapper px-3 mx-auto">
          <div className="auth-body-wrapper">
            <div className="logo-wrapper text-center">
              <img
                src="../assets/icons/eC-Card-Logo.svg"
                alt="EC Card Logo"
                className="logo"
              />
            </div>

            {linkSent ? (
              <div className="forgot-msg-wrapper">
                <div className="forgot-msg-txt py-4 fw-bold ">{sentMsg}</div>
                <Link to={`/${props.roleType}/login`}>


                  <div className="pb-3  pt-2 text-center">
                    <button className="btn btn-secondary-own btn-block btn-own" style={{ width: '100%' }}><i className="fas fa-arrow-left" style={{ marginRight: '5px' }}></i> Back to Login</button>

                    {/* <span className="text-white">{t("user.forgotPassword.backToLogin")}</span> */}

                  </div>
                </Link>
              </div>
            ) : (
              <form onSubmit={(e) => handleSubmit(e)} className="form-own">
                <>
                  <div className="pt-1">
                    <p className="login-text text-center fw-bold">
                      {t("user.forgotPassword.enterDetails")}
                    </p>

                    <div className="form-group reg-date login-page">
                      {/* <input
                        name="email"
                        placeholder="Email"
                        onChange={(ev) =>
                          validtedEmail ? null : validateMail(ev)
                        }
                        maxLength="40"
                        value={email}
                        className="form-control"
                        disabled={validtedEmail}
                      /> */}
                      <InputComponent
                        placeholder={t("user.forgotPassword.emailPlaceholder")}
                        label={t("user.forgotPassword.emailLabel")}
                        name="email"
                        type="text"
                        theme="primary"
                        color="#d7eff5"
                        inputFor="number"
                        maxLength={40}
                        value={email}
                        autoComplete={"email" + Math.random()}
                        handleCallback={(val, flag) => {
                          setInvalidEmail(flag);
                          setEmail(val);
                          if (val) {
                            setEmptyEmail(false);
                          } else {
                            setEmptyEmail(true);
                          }
                        }}

                      />
                      <div className="error-text font-12 pl-2">
                        {!email && emptyEmail && <span>{t("user.forgotPassword.emailRequired")}</span>}
                        {email && invalidEmail && <span>{t("user.forgotPassword.emailInvalid")}</span>}
                      </div>
                    </div>

                    <div className="form-group pt-3 forgot-password-action">
                      <Button
                        type="submit"
                        className="btn btn-secondary-own btn-block btn-own"
                      >
                        <span className=" text-color-primary">{validtedEmail
                          ? t("user.forgotPassword.sendLink")
                          : t("user.forgotPassword.validateEmail")}</span>
                      </Button>
                    </div>

                    <div className="pb-3  pt-2 text-center">
                      <Link to={`/${props.roleType}/login`}>
                        <span className="text-white"><i className="fas fa-arrow-left" style={{ marginRight: '5px' }}></i> {t("user.forgotPassword.backToLogin")}</span>
                      </Link>
                    </div>
                  </div>
                </>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ForgotPasswordComponent);
